import { createContext, useContext, useEffect, useState } from "react";
import { dianaApi } from "../../services";

const CasesContext = createContext();

export const CasesProvider = ({ children }) => {
  const [cases, setCases] = useState([]);
  const [casesLoad, setCasesLoad] = useState(true);
  const [showCases, setShowCases] = useState(false);
  const [degCaseCalc, setDegCaseCalc] = useState(0);
  const [actualCases, setActualCases] = useState([]);
  const [showCaseDesc, setShowCaseDesc] = useState(false);
  const [caseToShow, setCaseToShow] = useState();

  const getCaseToShow = (caseId) => {
    const post = cases.filter((elem) => elem.id === caseId);
    setCaseToShow(post[0]);
    setShowCaseDesc(true);
  };

  const getActualCases = (caseList) => {
    if (caseList) {
      setActualCases(
        cases.filter((item) => caseList.some((id) => id === item.id))
      );
    } else {
      setActualCases([]);
    }
  };

  const getCases = () => {
    dianaApi
      .get(`/case?_embed&per_page=100`)
      .then((response) => setCases(response.data))
      .then(() => setCasesLoad(false))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getCases();
  }, []);

  useEffect(() => {
    if (actualCases.length > 0) {
      setDegCaseCalc(360 / actualCases.length);
    }
  }, [actualCases]);

  return (
    <CasesContext.Provider
      value={{
        cases,
        showCases,
        setShowCases,
        casesLoad,
        degCaseCalc,
        actualCases,
        getActualCases,
        showCaseDesc,
        setShowCaseDesc,
        getCaseToShow,
        caseToShow,
      }}
    >
      {children}
    </CasesContext.Provider>
  );
};

export const useCases = () => useContext(CasesContext);
